import script from "./auto-add.vue?vue&type=script&lang=js"
export * from "./auto-add.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__